//
// Module for the correspondence review, batch review detail page.
//
rs.module("ui/content/fund/account/correspondencereview/batchreviewdetail",

    [ "controls/navigation/tabstrip" ],

    function (tabModule) {

        function initialize(constants, notesControl) {

            // When a note updates, update the comment header text in the tabs control
            notesControl.onNoteSaved(function (noteCount) {

                // Update comments tab text
                var tabText = constants.commentsTabText;
                if (noteCount > 0) {
                    tabText = tabText + ' (' + noteCount + ')';
                }
                tabModule.setTabText(constants.commentsTabKey, tabText);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);